import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listPublishedDoctors } from "@/lib/doctors.functions";
import { mergeDoctors, type MergedDoctor } from "@/lib/doctor-merge";
import type { DoctorRow } from "@/lib/doctors.functions";

export function useMergedDoctors(enabled = true, initialDoctors?: DoctorRow[]): MergedDoctor[] {
  const fetchDoctors = useServerFn(listPublishedDoctors);
  const { data = [] } = useQuery({
    queryKey: ["public", "doctors"],
    queryFn: () => fetchDoctors(),
    enabled,
    initialData: initialDoctors,
  });
  const doctors = data.length > 0 ? data : (initialDoctors ?? []);
  return useMemo(() => mergeDoctors(doctors), [doctors]);
}
